<template>
  <div class="root">
        <header>Device Permission Invocation List</header>
        <table>
            <tr>
                <th>Device Permission</th>
                <th>Service Function</th>
                <th>Description of Functional Scenarios</th>
                <th>Whether It Can Be Closed</th>
            </tr>
            <tr>
                <td>Network Access</td>
                <td>Core service function</td>
                <td>Read and update App content</td>
                <td>Yes. App content cannot be read and updated in real time after it is closed, and the app cannot be used normally</td>
            </tr>
            <tr>
                <td>Geographic Location</td>
                <td>Network environment Geographic detection & location Adding location in posts</td>
                <td>Users contact customer service staff to test the network environment & Add location in a post</td>
                <td>Yes. It will only affect the corresponding function after it is closed, and will not affect other app functions</td>
            </tr>
            <tr>
                <td>Media File Storage</td>
                <td>Stable operation of APP</td>
                <td>Log information recording and information caching</td>
                <td>Yes. It will only affect the corresponding function after it is closed, and will not affect other app functions</td>
            </tr>
            <tr>
                <td>Camera</td>
                <td>Core service function</td>
                <td>Take photos within the app</td>
                <td>Yes. It will only affect the corresponding </td>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>function after it is closed, and will not affect other app functions</td>
            </tr>
            <tr>
                <td>Microphone</td>
                <td>Core service function</td>
                <td>Voice messages/voice call</td>
                <td>Yes. It will only affect the corresponding function after it is closed, and will not affect other app functions</td>
            </tr>
            <tr>
                <td>Push</td>
                <td>Send notifications</td>
                <td>Push notifications</td>
                <td>Yes. It will only affect the corresponding function after it is closed, and will not affect other app functions</td>
            </tr>
            <tr>
                <td>Calendar</td>
                <td>Core service function</td>
                <td>Add events to calendar</td>
                <td>Yes. It will only affect the corresponding function after it is closed, and will not affect other app functions</td>
            </tr>
            <tr>
                <td>Bluetooth</td>
                <td>Core service function</td>
                <td>Use bluetooth earphones</td>
                <td>Yes. It will only affect the corresponding function after it is closed, and will not affect other app </td>
            </tr>
        </table>
    </div>
</template>  

<script>
export default {
  name: "privacy",
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.root{
    text-align: left;
    margin: 10px;
}
header{
    
    padding: 10px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 10px;
    font-weight: 900;
}
div {
    font-size: 25px;
    font-weight: 900;
}
b{
    font-size: 20px;
    font-weight: 900;
}

p{
    font-size: 16px;
    font-weight: 500;
}
table {
    border-collapse: collapse;
}

th, td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
}
td ,li{
    font-size: 16px;
}
a{
    color: blue;
}</style>
